module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"live":"Live","listen":"Listen now","error":"Network error","stop":"Stop"},"fr":{"live":"Direct","listen":"Écouter maintenant","error":"Erreur de lecture","stop":"Arrêter la lecture"}}')
  delete Component.options._Ctor
}
